import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function SidebarSection({
  titleWidth = 140,
  children,
}: {
  titleWidth?: number;
  children: React.ReactNode;
}) {
  return (
    <div className="pb-4 mb-2">
      <h3 className="h6 pb-2">
        <Skeleton width={titleWidth} height={22} />
      </h3>
      {children}
    </div>
  );
}

function CardSkeleton() {
  return (
    <div className="col-sm-6 col-xl-4">
      <div className="card shadow-sm border-0 h-100 overflow-hidden">
        {/* Badge "Novo/Usado" */}
        <div className="position-absolute start-0 top-0 pt-3 ps-3" style={{ zIndex: 1 }}>
          <Skeleton width={50} height={20} />
        </div>

        {/* Botão +/- comparativo */}
        <div className="position-absolute end-0 top-0 pt-3 pe-3" style={{ zIndex: 1 }}>
          <Skeleton circle width={28} height={28} />
        </div>

        {/* Imagem do carro */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <Skeleton height={200} width={300} />
        </div>

        {/* Corpo do card */}
        <div className="card-body position-relative pb-3">
          <h4 className="mb-1 fs-xs fw-normal text-uppercase">
            <Skeleton width={50} />
          </h4>
          <h3 className="h6 mb-2 fs-base">
            <Skeleton width="80%" />
          </h3>
          <p className="mb-2 fs-sm">
            <Skeleton width="65%" />
          </p>
          <Skeleton width="55%" />
          <p className="mt-2 fs-sm mb-0">
            <Skeleton width="70%" />
          </p>
        </div>

        {/* Footer com notas */}
        <div className="card-footer d-flex justify-content-around pt-3 text-nowrap">
          <Skeleton height={43} width={60} />
          <Skeleton height={43} width={60} />
        </div>
      </div>
    </div>
  );
}

export default function RankingSkeleton() {
  return (
    <main className="page-wrapper">
      <div className="container-fluid p-0">
        <div className="row g-0 mt-n3">
          {/* Sidebar de filtros */}
          <aside className="col-lg-4 col-xl-3 border-top-lg border-end-lg shadow-sm px-3 px-xl-4 px-xxl-5 pt-lg-2">
            <div className="py-lg-4">
              {/* Nota AutoPapo */}
              <SidebarSection titleWidth={130}>
                <div className="mb-3">
                  <Skeleton width={80} height={16} />
                  <Skeleton height={8} style={{ marginTop: 12 }} />
                </div>
                <div>
                  <Skeleton width={150} height={16} />
                  <Skeleton height={8} style={{ marginTop: 12 }} />
                </div>
              </SidebarSection>

              {/* Marca e Modelo */}
              <SidebarSection titleWidth={150}>
                <Skeleton width={130} height={16} style={{ marginBottom: 10 }} />
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: 8,
                  }}
                >
                  {Array.from({ length: 9 }).map((_, i) => (
                    <Skeleton key={i} height={70} />
                  ))}
                </div>
              </SidebarSection>

              {/* Novos ou Usados */}
              <SidebarSection titleWidth={140}>
                <div className="mb-2">
                  <Skeleton width="60%" height={20} />
                </div>
                <div>
                  <Skeleton width="55%" height={20} />
                </div>
              </SidebarSection>

              {/* Ano */}
              <SidebarSection titleWidth={50}>
                <div style={{ display: "flex", gap: 8 }}>
                  <Skeleton width="100%" height={36} />
                  <Skeleton width="100%" height={36} />
                </div>
              </SidebarSection>

              {/* Preço */}
              <SidebarSection titleWidth={60}>
                <div style={{ display: "flex", gap: 8 }}>
                  <Skeleton width="100%" height={36} />
                  <Skeleton width="100%" height={36} />
                </div>
              </SidebarSection>

              {/* Opcionais */}
              <SidebarSection titleWidth={90}>
                {Array.from({ length: 4 }).map((_, i) => (
                  <div key={i} className="mb-2">
                    <Skeleton width={`${60 + i * 5}%`} height={20} />
                  </div>
                ))}
              </SidebarSection>

              {/* Combustível */}
              <SidebarSection titleWidth={110}>
                {Array.from({ length: 4 }).map((_, i) => (
                  <div key={i} className="mb-2">
                    <Skeleton width={`${55 + i * 6}%`} height={20} />
                  </div>
                ))}
              </SidebarSection>
            </div>
          </aside>

          {/* Coluna principal */}
          <div className="col-lg-8 col-xl-9 position-relative overflow-hidden pt-4 px-3 px-xl-4 px-xxl-5">
            {/* Título + contagem */}
            <div className="d-sm-flex align-items-center justify-content-between pb-3 pb-sm-4">
              <h1 className="h2 mb-sm-0">
                <Skeleton width={150} />
              </h1>
              <div className="d-none d-sm-flex align-items-center flex-shrink-0">
                <Skeleton width={120} height={20} />
              </div>
            </div>

            {/* Busca + Ordenar */}
            <div className="d-sm-flex align-items-center justify-content-between pb-3 pb-sm-4">
              <div className="mw-200px" style={{ marginBottom: 10, width: 200 }}>
                <Skeleton height={36} />
              </div>
              <div
                className="d-flex align-items-center flex-shrink-0"
                style={{ marginBottom: 8, gap: 10 }}
              >
                <Skeleton width={90} height={20} />
                <Skeleton width={180} height={36} />
              </div>
            </div>

            {/* Cards */}
            <div className="row g-4 py-4">
              {Array.from({ length: 9 }).map((_, i) => (
                <CardSkeleton key={i} />
              ))}
            </div>

            {/* Paginação */}
            <div className="d-flex justify-content-center pt-3">
              <Skeleton width={280} height={38} />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
